<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/schedule',
          title: 'Classes & Workshops'
        }
      ]"
      :value="schedulePage.hero_section"
    >
      <template v-if="schedulePage.hero_section.cta" #cta>
        <HeroCta :value="schedulePage.hero_section.cta" />
      </template>
    </HeroSection>

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters-value="filtersValue"
        :show-embed-code="showEmbedCode"
        :show-past="showPast"
        :value="schedulePage.classes_section"
        :what-items="
          filtersValue.what && filtersValue.what.split(',').length > 1
            ? [
                {
                  title: `Products: ${filtersValue.what.replaceAll(',', ', ')}`,
                  value: filtersValue.what
                }
              ]
            : undefined
        "
        :what-menu="whatMenu"
        class="mb-16 hero-section hero-below-offset"
        main
      />
    </v-lazy>

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="schedulePage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'

const props = defineProps({
  banner: {
    default: undefined,
    type: Object
  },
  deliveryMethods: {
    required: true,
    type: Array
  },
  schedulePage: {
    required: true,
    type: Object
  },
  trainers: {
    required: true,
    type: Array
  },
  whatMenu: {
    required: true,
    type: Object
  }
})

const filtersValue = ref()
const showEmbedCode = ref(false)
const showPast = ref(false)

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore(props.trainers)

onBeforeMount(() => {
  const url = new URL(window.location.href)
  const what = url.searchParams.get('what')
  const who = url.searchParams.get('who')

  filtersValue.value = {
    ...(what ? { what: what.toUpperCase() } : undefined),
    ...(who ? { who: who.toUpperCase() } : undefined)
  }
  showEmbedCode.value = url.searchParams.get('showEmbedCode') === 'true'
  showPast.value = url.searchParams.get('showPast') === 'true'
})
</script>
